
var stache = require('can/view/stache/stache');
module.exports = stache("<div class=\"s-item-description\">\r\n    Holes\r\n    {{#each holeTags}}\r\n        {{#.}}\r\n            <span>{{title}}</span>\r\n        {{/.}}\r\n    {{/each}}\r\n</div>");